import RetailerSpecificFields from './retailer-specific-fields';

export default RetailerSpecificFields;
